import { types } from "./mutations";

export default {
  /*
   * Loads time data from a response body
   * sets current time window and max time
   * @param { Object } param0
   * @param { Array } data
   */
  loadTimeData: async ({ commit, state }, data) => {
    if (!(data && data.length > 0)) {
      return commit(types.SET_TIME_DATA, []);
    }
    // pick the time window from date widget
    let startDate = new Date(data[0].window_start);
    let endDate = new Date(data[0].window_end);

    // if there is no active time window set, set the active time window to be the current data window
    if (!state.activeTimeWindow) {
      commit(types.SET_ACTIVE_TIME_WINDOW, [
        startDate.getTime(),
        endDate.getTime(),
      ]);
      commit(types.SET_MAX_TIME, endDate.getTime()); // set max time
    }
    commit(types.SET_TIME_DATA, data);
  },
  /**
   * Generates the payload for time filters
   * @param {Object} param0
   */
  createTimePayload: async ({ state }) => {
    let payloadData = {};
    // check for active timeslice
    if (state.activeTimeSlice) {
      payloadData = {
        ...state.activeTimeSlice,
      };
    }
    // check for active time window
    if (state.activeTimeWindow && state.activeTimeWindow.length > 1) {
      payloadData = {
        ...payloadData,
        window: state.activeTimeWindow.map(item => item / 1000),
      };
    }

    // check the final payload
    if ((payloadData.t_start && payloadData.t_end) || payloadData.window) {
      return payloadData;
    } else {
      return null;
    }
  },

  /**
   * Creates payload for time filters
   * Checks if each of the filter is applied, and then adds to a payload which is returned
   */
  createTimeFilterpayload: async ({ state }) => {
    let payloadData = {};
    if (state.activeTimeSlice) {
      payloadData = {
        ...state.activeTimeSlice,
      };
    }
    // check for active time window
    if (state.activeTimeWindow && state.activeTimeWindow.length > 1) {
      payloadData = {
        ...payloadData,
        window: state.activeTimeWindow.map(item => item / 1000),
      };
    }
    // check for active days
    if (state.activeDays && state.activeDays.length > 0) {
      payloadData = {
        ...payloadData,
        days: state.activeDays,
      };
    }
    // check for active time peaks
    if (state.activePeaks && state.activePeaks.length > 0) {
      payloadData = {
        ...payloadData,
        time_slots: state.activePeaks.map(peakString => {
          return peakString.split("-").map(item => parseInt(item));
        }),
      };
    }

    return payloadData;
  },

  /**
   * Sets the active time slice
   */
  setActiveTimeSlice: async ({ commit }, timeSlice) => {
    commit(types.SET_ACTIVE_TIME_SLICE, timeSlice);
  },

  /**
   * Sets the active time window
   */
  setActiveTimeWindow: async ({ commit }, value) => {
    commit(types.SET_ACTIVE_TIME_WINDOW, value);
  },

  /**
   * Toggles the time filters, window selection popup
   */
  toggleTimeFilters: async ({ commit, state }) => {
    commit(types.SET_SHOW_TIME_FILTERS, !state.showTimeFilters);
  },

  /**
   * Toggles the bottom panel
   */
  toggleBottomPanel: async ({ commit, state }) => {
    commit(types.SET_SHOW_BOTTOM_PANEL, !state.showBottomPanel);
  },

  /**
   * Set the active days
   */
  setActiveDays: async ({ commit }, data) => {
    commit(types.SET_ACTIVE_DAYS, data);
  },

  /**
   * Sets the active peaks
   */
  setActivePeaks: async ({ commit }, data) => {
    commit(types.SET_ACTIVE_PEAKS, data);
  },

  /**
   * Resets the module with initial state
   */
  reset: async ({ commit }) => {
    commit(types.reset);
  },
};
